export const FORM_LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
];

const en = {
  steps: ['Start', 'Details', 'Last step'],
  firstName: 'Your First Name',
  lastName: 'Your Last Name',
  legalName: "Your Business/Organization's Legal Name",
  address: 'Your Business Address',
  addressPhUS: '123 Main Street, Austin, TX 78701',
  addressPhIntl: 'Street, City, State/Province, Postal Code',
  country: 'Country',
  selectCountry: 'Select country…',
  phoneLabel: 'Your Business Phone Number',
  phonePhUS: '(555) 123-4567',
  phonePhIntl: 'Phone number',
  email: 'Your Business Email',
  website: 'Your Website',
  teamLead: 'Name of team member(s) who will lead this project',
  teamLeadPh: 'First & Last name',
  greetingLabel: 'AI Build | What to say after greeting message?',
  greetingHelp: 'Introduction message after the person says "Hello" | If you want us to set this up for you, you can skip this question.',
  companyLabel: 'Company Details:',
  companyHelp: 'This section will contain all the details that you want the bot to pitch during the call. Keep it precise and to the point. Mention important details like specialty of company, offers, discounts, packages, pricing etc.',
  continueBtn: 'Continue',
  qualifyingLabel: 'Qualifying questions (if any)',
  qualifyingHelp: 'These are those questions that you want to ask in order to extract data from the lead.\n\nExamples:\n1. Ask the user if they are a homeowner in your service area.\n2. Ask if they have any upcoming projects.\n3. Ask for (or to confirm) their address and contact information.',
  faqsLabel: 'FAQs | Objection Handling',
  faqsHelp: 'Add distinct FAQs and objections your ideal customer typically has:\n1) Human: Why should I trust your business?\n   Bot: We are a family-owned company with 40 years of experience...\n\nProvide as much information as possible to further train the AI.',
  apptLabel: 'What Is The Location Of The Appointment After Being Set',
  domainLabel: 'Do you personally have access to your website domain? Or do you use a third-party service, such as a developer/website design company?',
  commsLabel: 'Besides using {platform} for daily communication between our team and yours, please list all other communication channels we can reach you by for any urgent needs',
  commsPh: 'ex: (123) 456-7890 and myemail@domain.com',
  teamEmailsLabel: 'Have additional emails of important team members to invite to group chat?',
  inputEmails: 'Input Emails Below',
  scriptsLabel: 'Do You Have Any Scripts To Upload?',
  scriptsIntro: 'Add any scripts here about your business that you would want the AI to follow…',
  dragDrop: 'Drag & drop a file or',
  browse: 'browse',
  maxFile: 'Max file size is 20 MB',
  twilioTitle: 'Twilio Account Creation *Very Important Step*',
  a2pTitle: 'A2P Authorization',
  a2pUS: 'All SMS and MMS messages sent to U.S. phone numbers using 10DLC phone numbers will fail if not registered with an application-to-person (A2P) Campaign.',
  a2pIntl: 'If your business will text U.S. phone numbers, Twilio requires A2P Campaign registration. Messaging regulations vary by country — our team will guide you through what applies to your region.',
  websiteLink: 'Website Link:',
  inviteEmail: 'Email to invite for A2P Completion:',
  twilioDone: 'Is Your Twilio Account Done?',
  bizType: 'Business Type',
  ein: 'Business EIN',
  taxId: 'Tax ID / VAT / Company Registration Number',
  areaCodes: 'Suggested Area Code(s)…We will choose from these area code(s)',
  submitBtn: 'Submit Onboarding Form',
  submitting: 'Submitting…',
  required: 'Required',
  validEmail: 'Enter a valid email',
  selectOne: 'Select one',
  submitFailed: 'Submission failed — please try again',
  uploadFailed: 'Upload failed — please try again',
  emailCopyCheckbox: '📩 Email me a copy of my responses',
  optional: '(optional)',
  opt: {},
};

const es = {
  steps: ['Inicio', 'Detalles', 'Último paso'],
  firstName: 'Tu nombre',
  lastName: 'Tus apellidos',
  legalName: 'Nombre legal de tu empresa/organización',
  address: 'Dirección de tu empresa',
  addressPhUS: '123 Main Street, Austin, TX 78701',
  addressPhIntl: 'Calle, Ciudad, Provincia, Código postal',
  country: 'País',
  selectCountry: 'Selecciona un país…',
  phoneLabel: 'Teléfono de tu empresa',
  phonePhUS: '(555) 123-4567',
  phonePhIntl: 'Número de teléfono',
  email: 'Correo electrónico de tu empresa',
  website: 'Tu sitio web',
  teamLead: 'Nombre del miembro o miembros del equipo que liderarán este proyecto',
  teamLeadPh: 'Nombre y apellidos',
  greetingLabel: 'AI Build | ¿Qué decir después del mensaje de saludo?',
  greetingHelp: 'Mensaje de introducción después de que la persona diga "Hola" | Si quieres que lo configuremos por ti, puedes omitir esta pregunta.',
  companyLabel: 'Detalles de la empresa:',
  companyHelp: 'Esta sección contendrá todos los detalles que quieres que el bot presente durante la llamada. Sé preciso y directo. Menciona detalles importantes como la especialidad de la empresa, ofertas, descuentos, paquetes, precios, etc.',
  continueBtn: 'Continuar',
  qualifyingLabel: 'Preguntas de calificación (si las hay)',
  qualifyingHelp: 'Estas son las preguntas que quieres hacer para obtener datos del cliente potencial.\n\nEjemplos:\n1. Pregunta si es propietario de una vivienda en tu zona de servicio.\n2. Pregunta si tiene proyectos próximos.\n3. Pide (o confirma) su dirección e información de contacto.',
  faqsLabel: 'Preguntas frecuentes | Manejo de objeciones',
  faqsHelp: 'Agrega preguntas frecuentes y objeciones típicas de tu cliente ideal:\n1) Humano: ¿Por qué debería confiar en tu empresa?\n   Bot: Somos una empresa familiar con 40 años de experiencia...\n\nProporciona toda la información posible para entrenar mejor a la IA.',
  apptLabel: '¿Dónde se realizará la cita una vez agendada?',
  domainLabel: '¿Tienes acceso personal al dominio de tu sitio web? ¿O usas un servicio de terceros, como un desarrollador o una empresa de diseño web?',
  commsLabel: 'Además de usar {platform} para la comunicación diaria entre nuestro equipo y el tuyo, indica todos los demás canales de comunicación donde podamos contactarte para cualquier urgencia',
  commsPh: 'ej: (123) 456-7890 y micorreo@dominio.com',
  teamEmailsLabel: '¿Tienes correos adicionales de miembros importantes del equipo para invitar al chat grupal?',
  inputEmails: 'Escribe los correos abajo',
  scriptsLabel: '¿Tienes guiones para subir?',
  scriptsIntro: 'Agrega aquí cualquier guion sobre tu negocio que quieras que la IA siga…',
  dragDrop: 'Arrastra y suelta un archivo o',
  browse: 'explora',
  maxFile: 'El tamaño máximo es 20 MB',
  twilioTitle: 'Creación de cuenta Twilio *Paso muy importante*',
  a2pTitle: 'Autorización A2P',
  a2pUS: 'Todos los mensajes SMS y MMS enviados a números de EE. UU. con números 10DLC fallarán si no están registrados en una campaña A2P (application-to-person).',
  a2pIntl: 'Si tu empresa enviará mensajes de texto a números de EE. UU., Twilio requiere el registro de una campaña A2P. Las regulaciones de mensajería varían según el país — nuestro equipo te guiará según tu región.',
  websiteLink: 'Enlace del sitio web:',
  inviteEmail: 'Correo a invitar para completar A2P:',
  twilioDone: '¿Ya está lista tu cuenta de Twilio?',
  bizType: 'Tipo de empresa',
  ein: 'EIN de la empresa',
  taxId: 'NIF / IVA / Número de registro de la empresa',
  areaCodes: 'Códigos de área sugeridos… Elegiremos entre estos códigos',
  submitBtn: 'Enviar formulario de onboarding',
  submitting: 'Enviando…',
  required: 'Obligatorio',
  validEmail: 'Introduce un correo válido',
  selectOne: 'Selecciona una opción',
  submitFailed: 'Error al enviar — inténtalo de nuevo',
  uploadFailed: 'Error al subir — inténtalo de nuevo',
  emailCopyCheckbox: '📩 Envíame una copia de mis respuestas por correo',
  optional: '(opcional)',
  opt: {
    'In-Person': 'En persona',
    'Phone Call': 'Llamada telefónica',
    'Other': 'Otro',
    'I have access': 'Tengo acceso',
    'Yes': 'Sí',
    'No': 'No',
    'I Have Finished Making My Twilio Account & Invited The Tech Team': 'Ya creé mi cuenta de Twilio e invité al equipo técnico',
    'I Need Help Creating My Twilio Account': 'Necesito ayuda para crear mi cuenta de Twilio',
    'Sole Proprietorship': 'Empresario individual',
    'Limited Liability Company (LLC)': 'Sociedad de responsabilidad limitada (LLC)',
    'C Corporation (C Corp)': 'Corporación C (C Corp)',
    'S Corporation (S Corp)': 'Corporación S (S Corp)',
    'Sole Proprietorship / Individual': 'Empresario individual / Autónomo',
    'Partnership': 'Sociedad',
    'Private Limited Company (Ltd)': 'Sociedad limitada (Ltd)',
    'Corporation': 'Corporación',
    'Non-Profit / NGO': 'Sin fines de lucro / ONG',
  },
};

const fr = {
  steps: ['Début', 'Détails', 'Dernière étape'],
  firstName: 'Votre prénom',
  lastName: 'Votre nom',
  legalName: 'Nom légal de votre entreprise/organisation',
  address: 'Adresse de votre entreprise',
  addressPhUS: '123 Main Street, Austin, TX 78701',
  addressPhIntl: 'Rue, Ville, Région, Code postal',
  country: 'Pays',
  selectCountry: 'Sélectionnez un pays…',
  phoneLabel: 'Numéro de téléphone de votre entreprise',
  phonePhUS: '(555) 123-4567',
  phonePhIntl: 'Numéro de téléphone',
  email: 'E-mail de votre entreprise',
  website: 'Votre site web',
  teamLead: "Nom du ou des membres de l'équipe qui dirigeront ce projet",
  teamLeadPh: 'Prénom et nom',
  greetingLabel: 'AI Build | Que dire après le message de salutation ?',
  greetingHelp: 'Message d\'introduction après que la personne dit « Bonjour » | Si vous souhaitez que nous le configurions pour vous, vous pouvez ignorer cette question.',
  companyLabel: "Détails de l'entreprise :",
  companyHelp: "Cette section contiendra tous les détails que le bot doit présenter pendant l'appel. Restez précis et concis. Mentionnez les détails importants comme la spécialité de l'entreprise, les offres, remises, forfaits, tarifs, etc.",
  continueBtn: 'Continuer',
  qualifyingLabel: 'Questions de qualification (le cas échéant)',
  qualifyingHelp: "Ce sont les questions que vous souhaitez poser pour obtenir des informations sur le prospect.\n\nExemples :\n1. Demandez s'il est propriétaire dans votre zone de service.\n2. Demandez s'il a des projets à venir.\n3. Demandez (ou confirmez) son adresse et ses coordonnées.",
  faqsLabel: 'FAQ | Traitement des objections',
  faqsHelp: "Ajoutez les FAQ et objections typiques de votre client idéal :\n1) Humain : Pourquoi devrais-je faire confiance à votre entreprise ?\n   Bot : Nous sommes une entreprise familiale avec 40 ans d'expérience...\n\nFournissez un maximum d'informations pour mieux entraîner l'IA.",
  apptLabel: 'Où aura lieu le rendez-vous une fois fixé ?',
  domainLabel: "Avez-vous personnellement accès au domaine de votre site web ? Ou utilisez-vous un prestataire tiers, comme un développeur ou une agence web ?",
  commsLabel: "En plus de {platform} pour la communication quotidienne entre nos équipes, veuillez indiquer tous les autres canaux par lesquels nous pouvons vous joindre en cas d'urgence",
  commsPh: 'ex : (123) 456-7890 et monemail@domaine.com',
  teamEmailsLabel: "Avez-vous d'autres e-mails de membres importants de l'équipe à inviter au chat de groupe ?",
  inputEmails: 'Saisissez les e-mails ci-dessous',
  scriptsLabel: 'Avez-vous des scripts à télécharger ?',
  scriptsIntro: "Ajoutez ici tout script sur votre entreprise que l'IA devra suivre…",
  dragDrop: 'Glissez-déposez un fichier ou',
  browse: 'parcourir',
  maxFile: 'Taille maximale : 20 Mo',
  twilioTitle: 'Création du compte Twilio *Étape très importante*',
  a2pTitle: 'Autorisation A2P',
  a2pUS: "Tous les SMS et MMS envoyés vers des numéros américains via des numéros 10DLC échoueront s'ils ne sont pas enregistrés dans une campagne A2P (application-to-person).",
  a2pIntl: "Si votre entreprise envoie des SMS vers des numéros américains, Twilio exige l'enregistrement d'une campagne A2P. La réglementation varie selon les pays — notre équipe vous guidera selon votre région.",
  websiteLink: 'Lien du site :',
  inviteEmail: "E-mail à inviter pour finaliser l'A2P :",
  twilioDone: 'Votre compte Twilio est-il prêt ?',
  bizType: "Type d'entreprise",
  ein: "EIN de l'entreprise",
  taxId: "Numéro fiscal / TVA / Numéro d'immatriculation",
  areaCodes: 'Indicatif(s) régionaux souhaités… Nous choisirons parmi ceux-ci',
  submitBtn: "Envoyer le formulaire d'onboarding",
  submitting: 'Envoi en cours…',
  required: 'Obligatoire',
  validEmail: 'Saisissez un e-mail valide',
  selectOne: 'Sélectionnez une option',
  submitFailed: "Échec de l'envoi — veuillez réessayer",
  uploadFailed: 'Échec du téléchargement — veuillez réessayer',
  emailCopyCheckbox: "📩 M'envoyer une copie de mes réponses par e-mail",
  optional: '(facultatif)',
  opt: {
    'In-Person': 'En personne',
    'Phone Call': 'Appel téléphonique',
    'Other': 'Autre',
    'I have access': "J'ai accès",
    'Yes': 'Oui',
    'No': 'Non',
    'I Have Finished Making My Twilio Account & Invited The Tech Team': "J'ai créé mon compte Twilio et invité l'équipe technique",
    'I Need Help Creating My Twilio Account': "J'ai besoin d'aide pour créer mon compte Twilio",
    'Sole Proprietorship': 'Entreprise individuelle',
    'Limited Liability Company (LLC)': 'Société à responsabilité limitée (LLC)',
    'C Corporation (C Corp)': 'C Corporation (C Corp)',
    'S Corporation (S Corp)': 'S Corporation (S Corp)',
    'Sole Proprietorship / Individual': 'Entreprise individuelle / Indépendant',
    'Partnership': 'Société de personnes',
    'Private Limited Company (Ltd)': 'Société à responsabilité limitée (Ltd)',
    'Corporation': 'Société par actions',
    'Non-Profit / NGO': 'À but non lucratif / ONG',
  },
};

const it = {
  steps: ['Inizio', 'Dettagli', 'Ultimo passo'],
  firstName: 'Il tuo nome',
  lastName: 'Il tuo cognome',
  legalName: 'Nome legale della tua azienda/organizzazione',
  address: 'Indirizzo della tua azienda',
  addressPhUS: '123 Main Street, Austin, TX 78701',
  addressPhIntl: 'Via, Città, Provincia, CAP',
  country: 'Paese',
  selectCountry: 'Seleziona un paese…',
  phoneLabel: 'Numero di telefono aziendale',
  phonePhUS: '(555) 123-4567',
  phonePhIntl: 'Numero di telefono',
  email: 'Email aziendale',
  website: 'Il tuo sito web',
  teamLead: 'Nome dei membri del team che guideranno questo progetto',
  teamLeadPh: 'Nome e cognome',
  greetingLabel: 'AI Build | Cosa dire dopo il messaggio di saluto?',
  greetingHelp: 'Messaggio introduttivo dopo che la persona dice "Pronto" | Se vuoi che lo configuriamo noi, puoi saltare questa domanda.',
  companyLabel: "Dettagli dell'azienda:",
  companyHelp: "Questa sezione conterrà tutti i dettagli che il bot deve presentare durante la chiamata. Sii preciso e diretto. Indica dettagli importanti come la specialità dell'azienda, offerte, sconti, pacchetti, prezzi ecc.",
  continueBtn: 'Continua',
  qualifyingLabel: 'Domande di qualificazione (se presenti)',
  qualifyingHelp: 'Queste sono le domande da porre per ottenere informazioni dal potenziale cliente.\n\nEsempi:\n1. Chiedi se è proprietario di casa nella tua zona di servizio.\n2. Chiedi se ha progetti in programma.\n3. Chiedi (o conferma) indirizzo e recapiti.',
  faqsLabel: 'FAQ | Gestione delle obiezioni',
  faqsHelp: "Aggiungi FAQ e obiezioni tipiche del tuo cliente ideale:\n1) Umano: Perché dovrei fidarmi della tua azienda?\n   Bot: Siamo un'azienda familiare con 40 anni di esperienza...\n\nFornisci più informazioni possibili per addestrare al meglio l'IA.",
  apptLabel: "Dove si svolgerà l'appuntamento una volta fissato?",
  domainLabel: 'Hai accesso personale al dominio del tuo sito web? Oppure usi un servizio di terzi, come uno sviluppatore o una web agency?',
  commsLabel: 'Oltre a {platform} per la comunicazione quotidiana tra i nostri team, elenca tutti gli altri canali con cui possiamo contattarti per urgenze',
  commsPh: 'es: (123) 456-7890 e miamail@dominio.com',
  teamEmailsLabel: 'Hai altre email di membri importanti del team da invitare alla chat di gruppo?',
  inputEmails: 'Inserisci le email qui sotto',
  scriptsLabel: 'Hai degli script da caricare?',
  scriptsIntro: "Aggiungi qui gli script sulla tua attività che vuoi far seguire all'IA…",
  dragDrop: 'Trascina un file oppure',
  browse: 'sfoglia',
  maxFile: 'Dimensione massima: 20 MB',
  twilioTitle: "Creazione dell'account Twilio *Passaggio molto importante*",
  a2pTitle: 'Autorizzazione A2P',
  a2pUS: 'Tutti gli SMS e MMS inviati a numeri statunitensi tramite numeri 10DLC falliranno se non registrati in una campagna A2P (application-to-person).',
  a2pIntl: "Se la tua azienda invierà SMS a numeri statunitensi, Twilio richiede la registrazione di una campagna A2P. Le normative variano da paese a paese — il nostro team ti guiderà in base alla tua regione.",
  websiteLink: 'Link del sito:',
  inviteEmail: 'Email da invitare per completare A2P:',
  twilioDone: 'Il tuo account Twilio è pronto?',
  bizType: 'Tipo di azienda',
  ein: "EIN dell'azienda",
  taxId: 'Partita IVA / Codice fiscale / Numero di registrazione',
  areaCodes: 'Prefissi suggeriti… Sceglieremo tra questi prefissi',
  submitBtn: 'Invia il modulo di onboarding',
  submitting: 'Invio in corso…',
  required: 'Obbligatorio',
  validEmail: 'Inserisci una email valida',
  selectOne: "Seleziona un'opzione",
  submitFailed: 'Invio non riuscito — riprova',
  uploadFailed: 'Caricamento non riuscito — riprova',
  emailCopyCheckbox: '📩 Inviami una copia delle mie risposte via email',
  optional: '(facoltativo)',
  opt: {
    'In-Person': 'Di persona',
    'Phone Call': 'Telefonata',
    'Other': 'Altro',
    'I have access': 'Ho accesso',
    'Yes': 'Sì',
    'No': 'No',
    'I Have Finished Making My Twilio Account & Invited The Tech Team': 'Ho creato il mio account Twilio e invitato il team tecnico',
    'I Need Help Creating My Twilio Account': 'Ho bisogno di aiuto per creare il mio account Twilio',
    'Sole Proprietorship': 'Ditta individuale',
    'Limited Liability Company (LLC)': 'Società a responsabilità limitata (LLC)',
    'C Corporation (C Corp)': 'C Corporation (C Corp)',
    'S Corporation (S Corp)': 'S Corporation (S Corp)',
    'Sole Proprietorship / Individual': 'Ditta individuale / Libero professionista',
    'Partnership': 'Società di persone',
    'Private Limited Company (Ltd)': 'Società a responsabilità limitata (Srl/Ltd)',
    'Corporation': 'Società per azioni',
    'Non-Profit / NGO': 'No-profit / ONG',
  },
};

const de = {
  steps: ['Start', 'Details', 'Letzter Schritt'],
  firstName: 'Ihr Vorname',
  lastName: 'Ihr Nachname',
  legalName: 'Rechtlicher Name Ihres Unternehmens / Ihrer Organisation',
  address: 'Ihre Geschäftsadresse',
  addressPhUS: '123 Main Street, Austin, TX 78701',
  addressPhIntl: 'Straße, Stadt, Bundesland, Postleitzahl',
  country: 'Land',
  selectCountry: 'Land auswählen…',
  phoneLabel: 'Ihre geschäftliche Telefonnummer',
  phonePhUS: '(555) 123-4567',
  phonePhIntl: 'Telefonnummer',
  email: 'Ihre geschäftliche E-Mail',
  website: 'Ihre Website',
  teamLead: 'Name der Teammitglieder, die dieses Projekt leiten',
  teamLeadPh: 'Vor- und Nachname',
  greetingLabel: 'AI Build | Was soll nach der Begrüßung gesagt werden?',
  greetingHelp: 'Einleitungsnachricht, nachdem die Person „Hallo" sagt | Wenn wir das für Sie einrichten sollen, können Sie diese Frage überspringen.',
  companyLabel: 'Unternehmensdetails:',
  companyHelp: 'Dieser Abschnitt enthält alle Details, die der Bot während des Anrufs präsentieren soll. Bleiben Sie präzise und auf den Punkt. Nennen Sie wichtige Details wie Spezialisierung, Angebote, Rabatte, Pakete, Preise usw.',
  continueBtn: 'Weiter',
  qualifyingLabel: 'Qualifizierungsfragen (falls vorhanden)',
  qualifyingHelp: 'Das sind die Fragen, die Sie stellen möchten, um Daten vom Lead zu erhalten.\n\nBeispiele:\n1. Fragen Sie, ob die Person Hausbesitzer in Ihrem Einzugsgebiet ist.\n2. Fragen Sie nach anstehenden Projekten.\n3. Erfragen (oder bestätigen) Sie Adresse und Kontaktdaten.',
  faqsLabel: 'FAQs | Einwandbehandlung',
  faqsHelp: 'Fügen Sie typische FAQs und Einwände Ihres idealen Kunden hinzu:\n1) Mensch: Warum sollte ich Ihrem Unternehmen vertrauen?\n   Bot: Wir sind ein Familienunternehmen mit 40 Jahren Erfahrung...\n\nJe mehr Informationen, desto besser wird die KI trainiert.',
  apptLabel: 'Wo findet der Termin nach der Buchung statt?',
  domainLabel: 'Haben Sie persönlich Zugriff auf Ihre Website-Domain? Oder nutzen Sie einen Drittanbieter, z. B. einen Entwickler oder eine Webdesign-Agentur?',
  commsLabel: 'Neben {platform} für die tägliche Kommunikation zwischen unseren Teams: Bitte nennen Sie alle weiteren Kanäle, über die wir Sie bei dringenden Anliegen erreichen können',
  commsPh: 'z. B.: (123) 456-7890 und meine@domain.com',
  teamEmailsLabel: 'Gibt es weitere E-Mail-Adressen wichtiger Teammitglieder für den Gruppenchat?',
  inputEmails: 'E-Mails unten eingeben',
  scriptsLabel: 'Haben Sie Skripte zum Hochladen?',
  scriptsIntro: 'Fügen Sie hier Skripte zu Ihrem Unternehmen hinzu, denen die KI folgen soll…',
  dragDrop: 'Datei hierher ziehen oder',
  browse: 'durchsuchen',
  maxFile: 'Maximale Dateigröße: 20 MB',
  twilioTitle: 'Twilio-Konto erstellen *Sehr wichtiger Schritt*',
  a2pTitle: 'A2P-Autorisierung',
  a2pUS: 'Alle SMS- und MMS-Nachrichten an US-Nummern über 10DLC-Nummern schlagen fehl, wenn sie nicht für eine Application-to-Person-(A2P)-Kampagne registriert sind.',
  a2pIntl: 'Wenn Ihr Unternehmen SMS an US-Nummern sendet, verlangt Twilio eine A2P-Kampagnenregistrierung. Die Vorschriften variieren je nach Land — unser Team unterstützt Sie bei den Anforderungen Ihrer Region.',
  websiteLink: 'Website-Link:',
  inviteEmail: 'Einzuladende E-Mail für den A2P-Abschluss:',
  twilioDone: 'Ist Ihr Twilio-Konto fertig?',
  bizType: 'Unternehmensform',
  ein: 'Unternehmens-EIN',
  taxId: 'Steuernummer / USt-IdNr. / Handelsregisternummer',
  areaCodes: 'Gewünschte Vorwahl(en)… Wir wählen aus diesen Vorwahlen',
  submitBtn: 'Onboarding-Formular absenden',
  submitting: 'Wird gesendet…',
  required: 'Pflichtfeld',
  validEmail: 'Gültige E-Mail eingeben',
  selectOne: 'Bitte auswählen',
  submitFailed: 'Senden fehlgeschlagen — bitte erneut versuchen',
  uploadFailed: 'Upload fehlgeschlagen — bitte erneut versuchen',
  emailCopyCheckbox: '📩 Eine Kopie meiner Antworten per E-Mail senden',
  optional: '(optional)',
  opt: {
    'In-Person': 'Vor Ort',
    'Phone Call': 'Telefonanruf',
    'Other': 'Sonstiges',
    'I have access': 'Ich habe Zugriff',
    'Yes': 'Ja',
    'No': 'Nein',
    'I Have Finished Making My Twilio Account & Invited The Tech Team': 'Mein Twilio-Konto ist fertig & das Tech-Team ist eingeladen',
    'I Need Help Creating My Twilio Account': 'Ich brauche Hilfe beim Erstellen meines Twilio-Kontos',
    'Sole Proprietorship': 'Einzelunternehmen',
    'Limited Liability Company (LLC)': 'Gesellschaft mit beschränkter Haftung (LLC)',
    'C Corporation (C Corp)': 'C-Corporation (C Corp)',
    'S Corporation (S Corp)': 'S-Corporation (S Corp)',
    'Sole Proprietorship / Individual': 'Einzelunternehmen / Selbstständig',
    'Partnership': 'Personengesellschaft',
    'Private Limited Company (Ltd)': 'GmbH / Private Limited (Ltd)',
    'Corporation': 'Kapitalgesellschaft',
    'Non-Profit / NGO': 'Gemeinnützig / NGO',
  },
};

export const TRANSLATIONS = { en, es, fr, it, de };
